"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const unknown_1 = __importDefault(require("./unknown"));
exports.default = (genderAsString) => {
    const gender = Number(genderAsString);
    switch (gender) {
        case 1:
        case 3:
        case 7:
            return { name: "male", title: "M" };
        case 2:
        case 4:
        case 8:
            return { name: "female", title: "Mme" };
        default:
            return (0, unknown_1.default)("has to be among 1, 2, 3, 4, 7 and 8");
    }
};
//# sourceMappingURL=makeGender.js.map